<template>
  <div>
    <nav class="nav-bar" :class="{ desktop: $isDesktop }">
      <div v-if="showBackButton" class="back" @click="back()">
        <svg
          v-once
          id="back-icon"
          width="100%"
          height="100%"
          viewBox="0 0 26 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xml:space="preserve"
          title="Back"
          style="
            fill-rule: evenodd;
            clip-rule: evenodd;
            stroke-linejoin: round;
            stroke-miterlimit: 1.41421;
          "
        >
          <path
            d="M12.679,3.045l-8.646,8.914l8.92,8.639c0.669,0.648 0.686,1.714 0.037,2.383c-0.648,0.668 -1.715,0.685 -2.385,0.037l-10.095,-9.777c-0.343,-0.333 -0.511,-0.776 -0.509,-1.219c-0.016,-0.443 0.139,-0.891 0.471,-1.234l9.785,-10.088c0.648,-0.668 1.716,-0.685 2.385,-0.038c0.668,0.648 0.685,1.715 0.037,2.383Z"
          />
          <path
            d="M24.677,2.858l-8.646,8.913l8.921,8.64c0.668,0.647 0.685,1.714 0.037,2.382c-0.648,0.668 -1.716,0.685 -2.385,0.037l-10.095,-9.777c-0.343,-0.333 -0.512,-0.776 -0.509,-1.219c-0.017,-0.442 0.138,-0.891 0.471,-1.234l9.784,-10.088c0.649,-0.668 1.716,-0.685 2.385,-0.037c0.669,0.648 0.686,1.715 0.037,2.383Z"
          />
        </svg>
      </div>
      <span class="page-title" :class="{ 'no-back-btn': !showBackButton }"
        ><slot name="header"
      /></span>
    </nav>
    <div>
      <slot :set-back-button-visibility="setBackButtonVisibility" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const appMenuStore = useAppMenuStore(usePinia())

    return { appMenuStore }
  },
})
class UserAccountSection extends Vue {
  appMenuStore: ReturnType<typeof useAppMenuStore>
  @Prop({ required: false })
  backUrl: string

  showBackButton = true

  setBackButtonVisibility(isVisible) {
    this.showBackButton = isVisible
  }

  async back() {
    const guestPagesOnly = [
      'accounts-signup',
      'accounts-reset-id-token',
      'favourites',
      'account-bookings-prettyId',
    ]
    const referrer: string = this.$routerClient.getReferrer()?.name || ''

    if (this.backUrl) {
      await this.$router.push(this.backUrl)
    } else if (guestPagesOnly.includes(referrer) || !referrer) {
      await this.$router.push('/')
      this.appMenuStore.showAccountMenu()
    } else {
      await this.$router.back()
    }
  }
}

export default toNative(UserAccountSection)
</script>

<style scoped>
nav {
  position: relative;
  text-align: center;
  justify-content: space-between;
  line-height: 1;
  display: flex;
  height: 10vw;
  width: 100%;
  min-height: 40px;
  background: var(--colour-mid-green);
}

.back {
  height: 2.25em;
  width: 2.25em;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5em;
}

.back svg {
  fill: white;
}

.page-title {
  font-weight: bold;
  font-size: var(--title);
  margin: auto;
  align-items: center;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.label {
  font-size: 0.5em;
  text-transform: uppercase;
  display: block;
  margin-top: 1vw;
}

nav button {
  border: none;
  font-weight: normal;
  border-radius: 0;
}

nav button:active {
  background: inherit;
  color: inherit;
}

/* desktop & tablet */
.desktop .page-title {
  margin: 1em 1em 1em calc(3vw + var(--edge-margin));
  font-size: 1.4em;
  padding: 0;
}

.desktop .back {
  display: none;
}
</style>
